export var copyLink = function (linkId) {
    var inputElement = document.getElementById(linkId);
    inputElement === null || inputElement === void 0 ? void 0 : inputElement.select();
    document.execCommand("copy");
    inputElement === null || inputElement === void 0 ? void 0 : inputElement.blur();
};
